module.exports = __webpack_public_path__ + "img/CI.d3acedd9.png";